import React, { FC, ReactElement, useState } from 'react';
import { useCommon } from 'src/AppState/Common';

import { EligibleUsersState } from 'src/domains/casino/webview/bonus-engine/campaign/player-management/eligible-users/EligibleUsers.state';
import { UploadCSV } from 'src/domains/casino/webview/bonus-engine/campaign/player-management/eligible-users/upload-area/UploadCSV';
import { Button } from 'src/domains/common/components/button/button';
import { Input } from 'src/domains/common/components/input/input';
import { observer } from 'src/utils/mobx-react';
import { UploadCSVState } from './UploadCSV.state';

interface EligibleUsersUploadAreaType {
    eligibleUsersState: EligibleUsersState;
    disabled: boolean;
}

export const EligibleUsersUploadArea: FC<EligibleUsersUploadAreaType> = observer(
    'EligibleUsersUploadArea',
    ({ eligibleUsersState, disabled }): ReactElement => {
        const common = useCommon();
        const { playerIdManualInput, additionDisabled, addPlayerId, fileToTable } = eligibleUsersState;

        const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
            playerIdManualInput.setAsVisited();

            if (e.key === 'Enter') {
                e.preventDefault();
            }
        };
        const [state] = useState(() => new UploadCSVState(common, fileToTable));

        return (
            <>
                <UploadCSV
                    label='Drag and Drop your CSV file'
                    uploadState={state}
                    disabled={disabled}
                />
                <div className='flex flex-col gap-2'>
                    <div className='block text-sm'>Player ID</div>
                    <div className='flex flex-row gap-4 flex-nowrap'>
                        <Input
                            formInputState={playerIdManualInput}
                            placeholder='Type'
                            onKeyDown={handleKeyDown}
                            errors={playerIdManualInput.errorsForView}
                            disabled={disabled}
                        />
                        <Button
                            className='w-36'
                            onClick={addPlayerId}
                            variant='outline'
                            disabled={disabled || additionDisabled}
                        >
                            Add
                        </Button>
                    </div>
                </div>
            </>
        );
    }
);
